export default "__VITE_ASSET__D$VKADHu__"